import { render, staticRenderFns } from "./CountryFlagDisplay.vue?vue&type=template&id=5175d842&scoped=true"
import script from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
export * from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
import style0 from "./CountryFlagDisplay.vue?vue&type=style&index=0&id=5175d842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175d842",
  null
  
)

export default component.exports